// src/pages/External/PreCollection/PreCollection.tsx
import { useToastContext } from "@/common/components/ui/toast/toast.context";
import { FormikProvider, useFormik } from "formik";
import VehicleInspectionFormBody from "./VehicleInspectionFormBody";
import { useState } from "react";

import { preUnlinkVehicleRenter, preUpdateVehicleVisualRecords } from "@/common/services/pre-collection.api";

type UnlinkDataResponse = {
  renterId: string;
  vehicleId: string;
  repossession?: {
    renter: {
      name: string;
    };
  };
};

function PreCollectionForm() {
  const { notifySuccess, notifyError } = useToastContext();
  const [formKey, setFormKey] = useState(0);

  const formik = useFormik({
    initialValues: {
      renterId: "",
      vehicleId: "",
      renterName: "",
      debitPaid: false,
      selectedLicensePlate: "",
      registers: [
        { type: "Frente do veículo", content: "" },
        { type: "Lateral direita do veículo", content: "" },
        { type: "Lateral esquerda do veículo", content: "" },
        { type: "Traseira do veículo", content: "" },
        { type: "Odômetro", content: "" },
      ],
      returnReason: "",
      partsEvaluation: {},
      observation: "",
      optionRepossesion: "DEFAULT",
    },
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      setSubmitting(true);
      try {
        
        const unlinkData = {
          debitPaid: values.debitPaid,
          optionRepossesion: values.optionRepossesion,
          partsEvaluation: values.partsEvaluation,
          observation: values.returnReason,
          licensePlate: values.selectedLicensePlate,
        };

        const resultUnlinkVehicle = await preUnlinkVehicleRenter(unlinkData);

        if (!resultUnlinkVehicle.ok) {
          notifyError(resultUnlinkVehicle.message as string);
          return;
        }

        notifySuccess("Veículo desvinculado com sucesso");
        const responseData = resultUnlinkVehicle.data as UnlinkDataResponse;
        const savePhotoDelivery = {
          renterId: responseData?.renterId,
          vehicleId: responseData?.vehicleId,
          photos: values.registers,
          licensePlate: values.selectedLicensePlate,
          returnReason: values.returnReason,
          nameRenter: responseData?.repossession?.renter.name,
        };

        const resultPhoto = await preUpdateVehicleVisualRecords(savePhotoDelivery);

        if (!resultPhoto.ok) {
          notifyError(resultPhoto.message as string);
          return;
        }

        notifySuccess("Fotos salvas com sucesso");
        resetForm();
        setFormKey((prevKey) => prevKey + 1);
      } catch (error) {
        notifyError("Ocorreu um erro ao processar a operação");
      } finally {
        setSubmitting(false);
      }
    },
  });


  return (
    <div className="bg-black w-full min-h-screen text-white">
      <div className="h-0.5 bg-redPrimary" />
      <header className="top-menu">
        <div className="logo-name pl-[10px]">
          <img
            alt="Locavibe logo"
            className="logo-img"
            src="/escudo_vermelho.png"
          />
          <div className="locavibe-backoffice">
            <div className="flex justify-center">
              <h2 className="loca">loca</h2>
              <h2 className="vibe">vibe</h2>
              <h2 className="backoffice">backoffice</h2>
            </div>
          </div>
        </div>
      </header>
      <div className="">
        <main className="overflow-y-auto h-[calc(100vh-80px)] scrollbar-hide">
          <div className="max-w-4xl mx-auto px-6 py-8 lg:px-8">
            <div className="mb-8">
              <h1 className="text-4xl font-bold text-white mb-2">
                Criar Novo Pre-recolhimento
              </h1>
              <p className="text-gray-400">
                Preencha os dados para registrar a inspeção do veículo
              </p>
            </div>

            <div className="bg-white text-black rounded-xl shadow-lg border border-red-500/20 p-8">
              <FormikProvider value={formik}>
                <form className="justify-center" onSubmit={formik.handleSubmit}>
                  <VehicleInspectionFormBody
                    key={formKey}
                    submitButtonText="Salvar Inspeção"
                    isLoading={formik.isSubmitting}
                  />
                </form>
              </FormikProvider>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
export default PreCollectionForm;
